(function () {
  'use strict';

  var DESKTOP_POINTS = [
    { x: 0, sx: 1, sy: 1, angle: 0, opacity: 1 },
    { x: 291, sx: 247 / 303, sy: 1, angle: 1.15, opacity: 1 },
    { x: 534, sx: 207 / 303, sy: 464 / 496, angle: 1.8, opacity: 1 },
    { x: 725, sx: 143 / 303, sy: 432 / 496, angle: 2.65, opacity: 1 },
    { x: 875, sx: 0.36, sy: 0.82, angle: 3.2, opacity: 0 }
  ];

  var MOBILE_POINTS = [
    { x: 0, sx: 219.919 / 303, sy: 360 / 496, angle: 0, opacity: 1 },
    { x: 211.2, sx: 179.274 / 303, sy: 360 / 496, angle: 3.2, opacity: 1 },
    { x: 376.5, sx: 150.242 / 303, sy: 336.774 / 496, angle: 3.45, opacity: 1 },
    { x: 526.2, sx: 103.79 / 303, sy: 313.548 / 496, angle: 5.55, opacity: 1 },
    { x: 650, sx: 0.28, sy: 0.58, angle: 6.4, opacity: 0 }
  ];

  var CARD_WIDTH = 303;
  var CARD_HEIGHT = 496;

  function modulo(value, length) {
    return ((value % length) + length) % length;
  }

  function interpolate(from, to, amount) {
    return from + (to - from) * amount;
  }

  function SphereGallery(root) {
    this.link = root.dataset.sgLink || '';
    this.viewport = root.querySelector('[data-sg-viewport]');
    this.cards = Array.prototype.slice.call(root.querySelectorAll('[data-sg-item]'));
    this.prevBtn = root.querySelector('[data-sg-prev]');
    this.nextBtn = root.querySelector('[data-sg-next]');
    this.mobileMq = window.matchMedia('(max-width: 720px)');
    this.count = this.cards.length;
    this.activeIndex = Math.floor(this.count / 2);
    this.viewIndex = this.activeIndex;
    this.renderViewIndex = this.viewIndex;
    this.animationFrame = 0;
    this.inputFrame = 0;
    this.dragPointerId = null;
    this.dragStartX = 0;
    this.dragStartView = this.viewIndex;
    this.dragDistance = 0;
    this.dragVelocity = 0;
    this.lastPointerX = 0;
    this.lastPointerTime = 0;
    this.isDragging = false;
    this.suppressClick = false;
    this.wheelIdleTimer = 0;
    this.wheelGestureActive = false;

    if (!this.viewport || this.count === 0) return;

    this.onPrev = this.onPrev.bind(this);
    this.onNext = this.onNext.bind(this);
    this.onPointerDown = this.onPointerDown.bind(this);
    this.onPointerMove = this.onPointerMove.bind(this);
    this.onEndDrag = this.onEndDrag.bind(this);
    this.onWheel = this.onWheel.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onStageClickCapture = this.onStageClickCapture.bind(this);
    this.onCardClick = this.onCardClick.bind(this);

    this.bind();
    this.render();
  }

  SphereGallery.prototype.wrapDistance = function (value) {
    var half = this.count / 2;
    return modulo(value + half, this.count) - half;
  };

  SphereGallery.prototype.roundedPolygonPath = function (vertices, radius, scaleX, scaleY) {
    var self = this;
    var rounded = vertices.map(function (vertex, index) {
      var previous = vertices[modulo(index - 1, vertices.length)];
      var next = vertices[modulo(index + 1, vertices.length)];
      var previousLength = Math.hypot(previous.x - vertex.x, previous.y - vertex.y);
      var nextLength = Math.hypot(next.x - vertex.x, next.y - vertex.y);
      var cornerRadius = Math.min(radius, previousLength / 2, nextLength / 2);

      return {
        vertex: vertex,
        incoming: {
          x: vertex.x + ((previous.x - vertex.x) / previousLength) * cornerRadius,
          y: vertex.y + ((previous.y - vertex.y) / previousLength) * cornerRadius
        },
        outgoing: {
          x: vertex.x + ((next.x - vertex.x) / nextLength) * cornerRadius,
          y: vertex.y + ((next.y - vertex.y) / nextLength) * cornerRadius
        }
      };
    });

    function point(vertex) {
      return (vertex.x / scaleX).toFixed(3) + ' ' + (vertex.y / scaleY).toFixed(3);
    }

    var path = 'M ' + point(rounded[0].outgoing);
    for (var index = 1; index <= rounded.length; index += 1) {
      var corner = rounded[index % rounded.length];
      path += ' L ' + point(corner.incoming) + ' Q ' + point(corner.vertex) + ' ' + point(corner.outgoing);
    }

    return 'path("' + path + ' Z")';
  };

  SphereGallery.prototype.cardClipPath = function (distance, geometry) {
    var width = CARD_WIDTH * geometry.sx;
    var height = CARD_HEIGHT * geometry.sy;
    var slant = height * geometry.angle / 100;
    var radius = this.mobileMq.matches ? 12 : 14;
    var vertices;

    if (distance < 0) {
      vertices = [
        { x: 0, y: slant },
        { x: width, y: 0 },
        { x: width, y: height },
        { x: 0, y: height - slant }
      ];
    } else {
      vertices = [
        { x: 0, y: 0 },
        { x: width, y: slant },
        { x: width, y: height - slant },
        { x: 0, y: height }
      ];
    }

    return this.roundedPolygonPath(vertices, radius, geometry.sx, geometry.sy);
  };

  SphereGallery.prototype.geometryAt = function (distance) {
    var points = this.mobileMq.matches ? MOBILE_POINTS : DESKTOP_POINTS;
    var absolute = Math.min(Math.abs(distance), 3.999);
    var lowerIndex = Math.min(Math.floor(absolute), points.length - 2);
    var amount = absolute - lowerIndex;
    var lower = points[lowerIndex];
    var upper = points[lowerIndex + 1];
    var direction = Math.sign(distance) || 1;

    return {
      x: interpolate(lower.x, upper.x, amount) * direction,
      sx: interpolate(lower.sx, upper.sx, amount),
      sy: interpolate(lower.sy, upper.sy, amount),
      angle: interpolate(lower.angle, upper.angle, amount),
      opacity: interpolate(lower.opacity, upper.opacity, amount)
    };
  };

  SphereGallery.prototype.render = function () {
    var self = this;

    this.cards.forEach(function (card, index) {
      var distance = self.wrapDistance(index - self.renderViewIndex);
      var geometry = self.geometryAt(distance);
      var absolute = Math.abs(distance);
      var isCentered = absolute < 0.001;
      var image = card.querySelector('img');

      card.style.zIndex = String(Math.max(1, 80 - Math.round(absolute * 20)));
      card.style.opacity = String(geometry.opacity);
      card.style.pointerEvents = absolute < 3.45 ? 'auto' : 'none';
      card.style.clipPath = self.cardClipPath(distance, geometry);
      card.style.transform = 'translate3d(calc(-50% + ' + geometry.x.toFixed(3) + 'px), -50%, 0) scale3d(' + geometry.sx.toFixed(5) + ', ' + geometry.sy.toFixed(5) + ', 1)';
      card.setAttribute('aria-current', isCentered ? 'true' : 'false');
      card.tabIndex = absolute < 3.45 ? 0 : -1;

      if (image) {
        image.style.transform = 'scale(' + interpolate(1, 1.16, Math.min(1, absolute / 3.5)).toFixed(4) + ')';
      }
    });
  };

  SphereGallery.prototype.stopAnimation = function () {
    cancelAnimationFrame(this.animationFrame);
    cancelAnimationFrame(this.inputFrame);
    this.animationFrame = 0;
    this.inputFrame = 0;
    this.viewport.classList.remove('is-settling');
  };

  SphereGallery.prototype.scheduleInputRender = function () {
    var self = this;
    if (this.inputFrame) return;

    function tick() {
      var diff = self.viewIndex - self.renderViewIndex;

      if (Math.abs(diff) < 0.001) {
        self.renderViewIndex = self.viewIndex;
        self.render();
        self.inputFrame = 0;
        return;
      }

      self.renderViewIndex += diff * 0.18;
      self.render();
      self.inputFrame = requestAnimationFrame(tick);
    }

    this.inputFrame = requestAnimationFrame(tick);
  };

  SphereGallery.prototype.settleTo = function (targetView) {
    var self = this;
    this.stopAnimation();

    var startView = this.viewIndex;
    var distance = targetView - startView;
    var duration = 520 + Math.min(160, Math.abs(distance) * 90);
    var startTime = performance.now();
    this.viewport.classList.add('is-settling');

    function tick(now) {
      var progress = Math.min(1, (now - startTime) / duration);
      var eased = 1 - Math.pow(1 - progress, 4);
      self.viewIndex = startView + distance * eased;
      self.renderViewIndex = self.viewIndex;
      self.render();

      if (progress < 1) {
        self.animationFrame = requestAnimationFrame(tick);
        return;
      }

      self.activeIndex = modulo(Math.round(targetView), self.count);
      self.viewIndex = self.activeIndex;
      self.renderViewIndex = self.viewIndex;
      self.viewport.classList.remove('is-settling');
      self.animationFrame = 0;
      self.render();
    }

    this.animationFrame = requestAnimationFrame(tick);
  };

  SphereGallery.prototype.step = function (direction) {
    this.settleTo(this.viewIndex + direction);
  };

  SphereGallery.prototype.onPrev = function (event) {
    if (event) event.preventDefault();
    this.step(-1);
  };

  SphereGallery.prototype.onNext = function (event) {
    if (event) event.preventDefault();
    this.step(1);
  };

  SphereGallery.prototype.onKeyDown = function (event) {
    if (event.key === 'ArrowLeft') this.step(-1);
    if (event.key === 'ArrowRight') this.step(1);
  };

  SphereGallery.prototype.onCardClick = function (event) {
    if (this.suppressClick || this.isDragging) return;
    if (!event.target.closest('[data-sg-item]')) return;
    if (!this.link) return;
    window.location.href = this.link;
  };

  SphereGallery.prototype.onPointerDown = function (event) {
    if (event.button !== 0) return;
    if (event.pointerType === 'mouse') event.preventDefault();
    this.stopAnimation();
    this.dragPointerId = event.pointerId;
    this.dragStartX = event.clientX;
    this.dragStartView = this.viewIndex;
    this.dragDistance = 0;
    this.dragVelocity = 0;
    this.lastPointerX = event.clientX;
    this.lastPointerTime = performance.now();
    this.isDragging = false;
    this.viewport.setPointerCapture && this.viewport.setPointerCapture(event.pointerId);
  };

  SphereGallery.prototype.onPointerMove = function (event) {
    if (event.pointerId !== this.dragPointerId) return;

    var now = performance.now();
    var elapsed = Math.max(1, now - this.lastPointerTime);
    this.dragDistance = event.clientX - this.dragStartX;
    this.dragVelocity = (event.clientX - this.lastPointerX) / elapsed;
    this.lastPointerX = event.clientX;
    this.lastPointerTime = now;

    if (!this.isDragging && Math.abs(this.dragDistance) > 5) {
      this.isDragging = true;
      this.viewport.classList.add('is-dragging');
    }

    if (!this.isDragging) return;

    event.preventDefault();
    var stepWidth = (this.mobileMq.matches ? MOBILE_POINTS : DESKTOP_POINTS)[1].x;
    this.viewIndex = this.dragStartView - this.dragDistance / stepWidth;
    this.scheduleInputRender();
  };

  SphereGallery.prototype.onEndDrag = function (event) {
    if (event.pointerId !== this.dragPointerId) return;
    this.viewport.releasePointerCapture && this.viewport.releasePointerCapture(event.pointerId);
    this.viewport.classList.remove('is-dragging');

    if (this.isDragging) {
      this.suppressClick = true;
      this.activeIndex = modulo(Math.round(this.viewIndex), this.count);
      this.scheduleInputRender();

      var self = this;
      window.setTimeout(function () {
        self.suppressClick = false;
      }, 0);
    } else if (this.link) {
      // mouse pointerdown 的 preventDefault 会吞掉 click，这里用非拖拽的 pointerup 跳转
      window.location.href = this.link;
    }

    this.dragPointerId = null;
    this.isDragging = false;
    this.dragDistance = 0;
  };

  SphereGallery.prototype.onWheel = function (event) {
    if (this.mobileMq.matches || this.dragPointerId !== null) return;

    var isHorizontalGesture = Math.abs(event.deltaX) > Math.max(1, Math.abs(event.deltaY) * 0.55);
    var isFineTrackpadGesture = event.deltaMode === 0 && Math.abs(event.deltaY) > 0 && Math.abs(event.deltaY) < 48;
    var horizontalDelta = isHorizontalGesture ? event.deltaX : ((event.shiftKey || isFineTrackpadGesture) ? event.deltaY : 0);

    if (!horizontalDelta) return;
    event.preventDefault();

    if (!this.wheelGestureActive) {
      this.stopAnimation();
      this.wheelGestureActive = true;
      this.viewport.classList.add('is-scrolling');
    }

    var stepWidth = DESKTOP_POINTS[1].x;
    var limitedDelta = Math.max(-100, Math.min(100, horizontalDelta));
    this.viewIndex += limitedDelta / stepWidth;
    this.scheduleInputRender();

    var self = this;
    window.clearTimeout(this.wheelIdleTimer);
    this.wheelIdleTimer = window.setTimeout(function () {
      self.wheelGestureActive = false;
      self.viewport.classList.remove('is-scrolling');
      self.settleTo(Math.round(self.viewIndex));
    }, 110);
  };

  SphereGallery.prototype.onStageClickCapture = function (event) {
    if (!this.suppressClick) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  };

  SphereGallery.prototype.onResize = function () {
    this.renderViewIndex = this.viewIndex;
    this.render();
  };

  SphereGallery.prototype.bind = function () {
    if (this.prevBtn) this.prevBtn.addEventListener('click', this.onPrev);
    if (this.nextBtn) this.nextBtn.addEventListener('click', this.onNext);
    this.viewport.addEventListener('pointerdown', this.onPointerDown);
    this.viewport.addEventListener('pointermove', this.onPointerMove);
    this.viewport.addEventListener('pointerup', this.onEndDrag);
    this.viewport.addEventListener('pointercancel', this.onEndDrag);
    this.viewport.addEventListener('wheel', this.onWheel, { passive: false });
    this.viewport.addEventListener('click', this.onStageClickCapture, true);
    this.viewport.addEventListener('click', this.onCardClick);
    document.addEventListener('keydown', this.onKeyDown);
    window.addEventListener('resize', this.onResize);
  };

  SphereGallery.prototype.destroy = function () {
    if (this.prevBtn) this.prevBtn.removeEventListener('click', this.onPrev);
    if (this.nextBtn) this.nextBtn.removeEventListener('click', this.onNext);
    this.viewport.removeEventListener('pointerdown', this.onPointerDown);
    this.viewport.removeEventListener('pointermove', this.onPointerMove);
    this.viewport.removeEventListener('pointerup', this.onEndDrag);
    this.viewport.removeEventListener('pointercancel', this.onEndDrag);
    this.viewport.removeEventListener('wheel', this.onWheel, { passive: false });
    this.viewport.removeEventListener('click', this.onStageClickCapture, true);
    this.viewport.removeEventListener('click', this.onCardClick);
    document.removeEventListener('keydown', this.onKeyDown);
    window.removeEventListener('resize', this.onResize);
    cancelAnimationFrame(this.animationFrame);
    cancelAnimationFrame(this.inputFrame);
    window.clearTimeout(this.wheelIdleTimer);
  };

  function initAll() {
    document.querySelectorAll('[data-sphere-gallery]').forEach(function (root) {
      if (root.dataset.sgReady === 'true') return;
      root.dataset.sgReady = 'true';
      root._sgInstance = new SphereGallery(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target;
    if (!section) return;
    section.querySelectorAll('[data-sphere-gallery]').forEach(function (root) {
      if (root._sgInstance) {
        root._sgInstance.destroy();
        root._sgInstance = null;
      }
      root.dataset.sgReady = '';
    });
    initAll();
  });
})();
